export const getToken = (item) =>{
return window.localStorage.getItem(item);
}